import { gql } from '@apollo/client';

export const UPDATE_HEALTH_CHECKUP_INSTITUTION = gql`
  mutation updateHealthCheckupInstitution($input: UpdateHealthCheckupInstitutionInput!) {
    updateHealthCheckupInstitution(input: $input) {
      healthCheckupInstitution {
        id
      }
    }
  }
`;

export interface UpdateHealthCheckupInstitutionQueryVariables {
  input: {
    id: number;
    healthCheckupInstitutionId: string;
    name: string;
    location: string;
  };
}
